import React from "react";
import { graphql } from "gatsby";
import { PhotoGallery } from "./PhotoGallery";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentMediaImage,
  StringValue,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatImages } from "../../../lib/images";

interface Props extends KontentComponentLayout, KontentComponentSettings {
  id: string;
  title: StringValue;
  description: StringValue;
  photo_gallery: {
    value: KontentMediaImage[];
  };
}

const PhotoGalleryContainer: React.FC<Props> = ({
  component_layout__component_width,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
  id,
  photo_gallery,
  title,
  description,
}) => {
  const componentWidth = getMultiChoice(component_layout__component_width);
  const photoGallery =
    photo_gallery &&
    photo_gallery?.value.map(
      (photo) => formatImages(photo.elements).largeImage
    );

  return (
    <PhotoGallery
      id={id}
      width={componentWidth}
      title={title.value}
      description={description.value}
      photoGallery={photoGallery}
      anchor={component_settings__anchor_name.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
    ></PhotoGallery>
  );
};

export default PhotoGalleryContainer;

export const fragmentPhotoGalleryContainer = graphql`
  fragment PhotoGallery on kontent_item_component___photo_gallery {
    system {
      id
      codename
    }
    internal {
      type
    }
    elements {
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
      title {
        value
      }
      description {
        value
      }
      photo_gallery {
        value {
          ...kontentMediaImage
        }
      }
    }
  }
`;
